import { Pipe, PipeTransform } from '@angular/core';
import { BehaviorScreen } from '../models/view-models/monitor-models/screen.type';

@Pipe({
  name: 'allMonitorsChecked'
})
export class AllMonitorsCheckedPipe implements PipeTransform {

  transform(selectedMonitors: BehaviorScreen[], filteredMonitors: BehaviorScreen[]): boolean {

    if (!selectedMonitors || !filteredMonitors) {
      return false;
    }

    const monHandlers = selectedMonitors.map(screen => screen.MonitorHandler);

    return !!filteredMonitors.length &&
      filteredMonitors.every(location => monHandlers.includes(location.MonitorHandler));
  }

}
